
// env.js
const ENV = process.env.NODE_ENV; // 从环境变量获取当前环境
console.log(ENV);

let apiUrlWithoutPort;
let apiUrl;
let webUrl;

if (ENV === 'development') {
    // apiUrl = 'http://localhost:8000'; // 开发环境  // 只要是用 npm run serve 开启的服务就是开发环境
    // apiUrl = 'http://192.168.124.12:8000'; // 如果要用手机访问后端数据: 必须要使用具体的本地ip地址! (根据ifconfig可得到!) (否则的话, 用localhost即可)
    // apiUrl = 'http://192.168.3.23:8000'; // 如果要用手机访问后端数据: 必须要使用具体的本地ip地址! (根据ifconfig可得到!)

    // apiUrlWithoutPort = 'http://192.168.3.114' // 石佛寺ip
    // apiUrlWithoutPort = 'http://192.168.28.9' // 丽水ip
    // apiUrlWithoutPort = 'http://192.168.31.149' // 丽水ip
    apiUrlWithoutPort = 'http://localhost' // 本地ip

    apiUrl = apiUrlWithoutPort + ':8000'  // 后端url
    webUrl = apiUrlWithoutPort + ':8080' // 前端url

} else if (ENV === 'production') {
    // 生产环境不需要加端口的原因: 在nginx代理配置文件中已经指定了/api是访问8000端口
    apiUrl = 'https://nuanyu.site'; // 生产环境  // 只要是 npm run build 编译后执行的就是生产环境!!
    webUrl = 'https://nuanyu.site'; // 前端url
}

// apiUrl = 'http://localhost:8000'
// apiUrl = 'https://nuanyu.site'

export default {
    apiUrl, webUrl,
};
